<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="title" :subTitle="subTitle" :btnBack="true"
                @btnBackClick="handleBackClick"
        />
        <section :class="$style.body">

            <div :class="$style.footer">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="按季度" name="first">
                        <QuarterItem ref="byQuarter" :index="index"/>
                    </el-tab-pane>
                    <el-tab-pane label="按月度" name="second">
                        <MonthlyItem ref="byMonthly" :index="index"/>
                    </el-tab-pane>
                </el-tabs>

            </div>
        </section>
    </div>
</template>
<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import QuarterItem from './item/quarterItem.vue'
    import MonthlyItem from './item/monthlyItem.vue'
    export default {
        data () {
            return {
                loading: false,
                tags: ['考勤', '门店详情'],
                title: '门店',
                subTitle: '加班明细',

                item1: {
                    tableData: []
                },
                activeName: 'first'
            }
        },
        components: {
            navBar,
            QuarterItem,
            MonthlyItem
        },
        computed: {
            isDisabled () {
                if (this.message) {
                    return false
                }
                return true
            }
        },
        created () {

            let obj = this.$store.getters.getStore
            this.title = obj.storeName

        },
        methods: {
            // tab切换
            handleClick(tab) {


                if (tab.index === "0") {
                    this.activeName = 'first'
                    this.$refs.byQuarter.getOtResultByQuarter()
                } else {
                    this.activeName = 'second'
                    this.$refs.byMonthly.getOtResultByQuarter()
                }

            },
            // 返回按钮
            handleBackClick () {
                this.$router.push({
                    path: '/attendance'
                })
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';
    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;
        .body {

            .title {
                font-size:$fontSize;
                line-height:$fontSize;
                em {
                    display: inline-block;
                    margin-right: 50px;
                    color:#000000;
                }
                span {
                    display: inline-block;
                    color: #4a90e2;
                    margin-right: 30px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/attendance/overtimeDetails/index.vue